import { IAnalyticSdr } from 'types/analyticsSdr';

/**
 * Analytics SDR for Dashboard Domain.
 * This information should match the values in the SDR Excel file referenced here:
 * https://chalk.charter.com/display/ERSPM/FE+Analytics
 */

const siteSection = 'Dashboard';

export const dashboardAnalytics: IAnalyticSdr = {
  dashboard: {
    siteSection,
    buttonClicks: {
      refreshReportsBtn: {
        itemClicked: 'Refresh Reports',
      },
    },
  },
};
